/**
 * Filtre rapide côté client, appliqué sur des données déjà chargées (ex:
 * pavés KPI cliquables "Total"/"Ouvertes"/"En retard" en haut des pages de
 * tableaux). Se synchronise avec le paramètre d'URL `?qf=<clef>` pour
 * permettre un lien direct depuis les Alertes Sécurité du Dashboard (un
 * clic sur une alerte navigue vers la page concernée avec le filtre déjà
 * appliqué).
 *
 * `predicates` : objet { clef: (ligne) => boolean }.
 */
import { useCallback, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

export default function useQuickFilter(predicates) {
  const [searchParams, setSearchParams] = useSearchParams();
  const [active, setActive] = useState(null);

  useEffect(() => {
    const qf = searchParams.get("qf");
    if (qf && predicates[qf]) {
      setActive(qf);
      const next = new URLSearchParams(searchParams);
      next.delete("qf");
      next.delete("tab");
      setSearchParams(next, { replace: true });
    }
    // Uniquement au montage : le paramètre d'URL n'est qu'un déclencheur
    // initial, ensuite le filtre est piloté par les clics sur les pavés KPI.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const toggle = useCallback((key) => setActive((prev) => (prev === key ? null : key)), []);
  const clear = useCallback(() => setActive(null), []);
  const apply = useCallback(
    (items) => (active && predicates[active] ? items.filter(predicates[active]) : items),
    [active, predicates]
  );

  return { active, toggle, clear, apply };
}
